import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const UnitOfMeasureList = () => {    
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="unitOfMeasure"
                hasCode={true}
                hasDescription={true}
            />
        </DashboardLayout>
    )
};

export default UnitOfMeasureList;
